import { useEffect } from "react";

const syrianCities = [
  "دمشق",
  "ريف دمشق",
  "القلمون",
  "حمص",
  "ريف حمص",
  "طرطوس",
  "ريف طرطوس",
  "حماة",
  "ريف حماة",
  "درعا",
  "اللاذقية",
  "ريف اللاذقية",
  "حلب",
  "ريف حلب",
  "القامشلي",
  "الرقة",
  "دير الزور",
  "البوكمال",
  "الحسكة",
];

export default function CustomInput({
  title,
  id,
  value,
  onChange,
  type = "text",
  direction = "rtl",
  required = false,
  isDisabled = false,
  max = "",
  min = "",
  className = "",
  options,
}) {
  useEffect(() => {
    if (
      type === "number" &&
      min &&
      (value === "" || value === undefined || value === null)
    ) {
      onChange({ name: id, value: min });
    }
  }, [id, min, onChange, type, value]);

  const commonClass =
    "portal-input mt-2 block h-11 w-full px-4 py-2.5 text-sm placeholder:text-right";

  const inputProps = {
    id,
    name: id,
    type,
    className: commonClass,
    style: { direction },
    value,
    onChange: (e) => onChange(e.target),
    required,
    disabled: isDisabled,
    autoComplete: "off",
    ...(type === "text" && max ? { maxLength: max } : {}),
    ...(type === "text" && min ? { minLength: min } : {}),
    ...(type === "number" && max ? { max } : {}),
    ...(type === "number" && min ? { min } : {}),
    ...(type === "number" ? { step: "any", inputMode: "decimal" } : {}),
  };

  const renderSelect = (list, placeholder) => (
    <select
      id={id}
      name={id}
      value={value}
      onChange={(e) => onChange(e.target)}
      className={commonClass}
      disabled={isDisabled}
      required
      style={{ direction }}
    >
      <option value="">{placeholder}</option>
      {list.map((item) => (
        <option key={item.value || item} value={item.value || item}>
          {item.label || item}
        </option>
      ))}
    </select>
  );

  return (
    <div className={`relative ${className}`}>
      <label htmlFor={id} className="text-sm font-medium" style={{ color: "var(--layout-text)" }}>
        {title}
      </label>
      {required ? <span className="font-bold text-red-600">*</span> : null}

      {type === "select"
        ? renderSelect(
            (options || "")
              .split("-")
              .filter(Boolean)
              .map((item) => ({ value: item, label: item })),
            "قم بالتحديد"
          )
        : id === "city"
          ? renderSelect(syrianCities, "اختر المحافظة")
          : (
            <input
              {...inputProps}
              onWheel={(e) => e.target.blur()}
              placeholder={
                type === "number"
                  ? min && max
                    ? `أقل قيمة (${min}) - أعلى قيمة (${max})`
                    : min
                      ? `أقل قيمة (${min})`
                      : max
                        ? `أعلى قيمة (${max})`
                        : ""
                  : ""
              }
            />
          )}
    </div>
  );
}
